import React from "react";
import { useTranslation } from "react-i18next";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
} from "recharts";

export default function GrupArgeReactiveEnergyPie({ importVal = 0, exportVal = 0 }) {
    const { t } = useTranslation();
    const realImport = importVal || 0;
    const realExport = exportVal || 0;

    const drawImport = realImport > 0 ? realImport : 0.001;
    const drawExport = realExport > 0 ? realExport : 0.001;

    const formatScaledEnergy = (rawValue, baseUnit = "VArh") => {
        const prefixes = ["", "k", "M", "G", "T", "P"];
        let value = Number(rawValue ?? 0);
        let idx = 0;

        while (Math.abs(value) >= 1000 && idx < prefixes.length - 1) {
            value /= 1000;
            idx += 1;
        }

        return {
            valueText: Number.isFinite(value) ? value.toFixed(3) : "0.000",
            unitText: `${prefixes[idx]}${baseUnit}`,
        };
    };

    // Grup Arge terminolojisi
    const data = [
        { name: t('dashboard.inductiveEnergy'), value: drawImport },
        { name: t('dashboard.capacitiveEnergy'), value: drawExport },
    ];

    const COLORS = ["#3B82F6", "#EF4444"];

    return (
        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('dashboard.reactiveEnergyDist')}
            </h3>

            <div className="flex items-center justify-center h-72">
                <PieChart width={300} height={300}>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="60%"
                        outerRadius={110}
                        dataKey="value"
                    >
                        {data.map((_, i) => (
                            <Cell key={i} fill={COLORS[i]} />
                        ))}
                    </Pie>

                    <Tooltip
                        formatter={(v, _, item) => {
                            const value = Number(item?.payload?.value) || 0;
                            const scaled = formatScaledEnergy(value * 1000, "VArh");
                            return `${scaled.valueText} ${scaled.unitText}`;
                        }}
                    />
                    <Legend
                        layout="horizontal"
                        align="center"
                        verticalAlign="bottom"
                        wrapperStyle={{
                            transform: "translateY(15px)",
                        }}
                    />
                </PieChart>
            </div>
        </div>
    );
}
